import React from 'react';
import CardItem from './Carditem';
import './Cards.css';

function Cards() {
    return (
        <div className="cards">
            <h1>Checkout these Epic Destinations</h1>
            <div className="cards__container">
                <div className="cards__wrapper">
                    <ul className="cards__items">
                        <CardItem 
                            src="images/img-9.jpg"
                            text="Explore the hidden waterfall deep inside the Amazon Jungle"
                            label="Adventure"
                            path="/services"
                        />
                        <CardItem 
                            src="images/img-8.jpg"
                            text="Enjoy a one week trip to the Sahara and see the wonders in it"
                            label="Adventure"
                            path="/services"
                        />
                    </ul>
                    <ul className="cards__items">
                        <CardItem 
                            src="images/img-5.jpg"
                            text="Lets go for a little 3 day hike in the outskirts of New York"
                            label="Adventure"
                            path="/services"
                        />
                        <CardItem 
                            src="images/img-6.jpg"
                            text="Lets go for a little 3 day hike in the outskirts of New York"
                            label="Adventure"
                            path="/services"
                        />
                        <CardItem 
                            src="images/img-7.jpg"
                            text="Lets go for a little 3 day hike in the outskirts of New York"
                            label="Adventure"
                            path="/services"
                        />
                    </ul>
                </div>
            </div>
        </div>
    );
}


export default Cards;